import React from 'react';

const Products = () => {
  const products = [
    {
      name: 'Ecomart.ng',
      description: 'A robust online marketplace connecting buyers and sellers across Nigeria. Features include secure payments, vendor dashboards, and real-time inventory management.',
      image: 'https://ecomart.ng/static/media/logo.36c428530d8f25b5ee72.png',
      features: ['Multi-vendor Support', 'Secure Payments', 'Real-time Analytics', 'Mobile Responsive'],
      link: 'https://ecomart.ng',
      icon: '🛒'
    },
    {
      name: 'Diceace21.com',
      description: 'A cutting-edge betting platform with live odds, multiple game options, and secure transaction processing for an immersive gaming experience.',
      image: 'https://diceace21.com/static/media/logo.00dfb361eb59d11c00a3.png',
      features: ['Live Betting', 'Multiple Games', 'Instant Payouts', '24/7 Support'],
      link: 'https://diceace21.com',
      icon: '🎲'
    }
  ];

  return (
    <section id="products" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-sals-dark mb-4">
            Our <span className="text-sals-primary">Products</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-sals-primary to-sals-light mx-auto rounded-full"></div>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            Discover our innovative solutions that are transforming businesses and user experiences
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid lg:grid-cols-2 gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl shadow-xl overflow-hidden transform hover:-translate-y-2 transition-all duration-500 hover:shadow-2xl"
            >
              {/* Product Image */}
              <div className="relative overflow-hidden h-64">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-sals-dark/70 to-transparent"></div>
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full w-12 h-12 flex items-center justify-center text-2xl shadow-lg">
                  {product.icon}
                </div>
              </div>

              {/* Product Content */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-sals-dark mb-3">
                  {product.name}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {product.description}
                </p>

                {/* Features */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {product.features.map((feature, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-sals-light/10 text-sals-primary text-xs rounded-full font-semibold"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                {/* Call to Action */}
                <div className="flex items-center justify-between">
                  <a
                    href={product.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center space-x-2 text-sals-primary font-semibold hover:text-sals-dark transition-colors group"
                  >
                    <span>Visit Website</span>
                    <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </a>
                  {/* <button className="px-4 py-2 bg-sals-primary text-white rounded-lg hover:bg-sals-dark transition-colors text-sm font-semibold">
                    Learn More
                  </button> */}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { number: '50+', label: 'Projects Completed', icon: '🚀' },
            { number: '30+', label: 'Happy Clients', icon: '😊' },
            { number: '10+', label: 'Active Products', icon: '💎' },
            { number: '5+', label: 'Years Experience', icon: '🏆' }
          ].map((stat, idx) => (
            <div key={idx} className="text-center p-4 bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow">
              <div className="text-3xl mb-2">{stat.icon}</div>
              <div className="text-2xl font-bold text-sals-primary">{stat.number}</div>
              <div className="text-sm text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;